
import React, { useState } from 'react';
import { Modal, Button, TextArea, Form, Dropdown, Icon, Message } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../app/stores/store';
import { PostVisibility } from '../../app/models/Playground';

export const CreatePostModal = observer(() => {
  const { playgroundStore } = useStore();
  const { t } = useTranslation();

  const [content, setContent] = useState('');
  const [mediaUrl, setMediaUrl] = useState('');
  const [visibility, setVisibility] = useState<PostVisibility>(PostVisibility.Standard);
  const [submitting, setSubmitting] = useState(false);

  const visibilityOptions = [
    { key: 'standard',    value: PostVisibility.Standard,    text: t('playground.visibility.public'),      icon: 'globe' },
    { key: 'followers',   value: PostVisibility.Followers,   text: t('playground.visibility.followers'),   icon: 'users' },
    { key: 'friendsOnly', value: PostVisibility.FriendsOnly, text: t('playground.visibility.friendsOnly'), icon: 'lock' },
  ];

  const handleSubmit = async () => {
    if (!content.trim()) return;
    setSubmitting(true);
    await playgroundStore.createPost({ content: content.trim(), mediaUrl: mediaUrl.trim() || undefined, visibility });
    setContent('');
    setMediaUrl('');
    setVisibility(PostVisibility.Standard);
    setSubmitting(false);
  };

  const handleClose = () => {
    setContent('');
    setMediaUrl('');
    playgroundStore.setCreatePostModalOpen(false);
  };

  return (
    <Modal open={playgroundStore.createPostModalOpen} onClose={handleClose} size='small' closeIcon>
      <Modal.Header>
        <Icon name='pencil' /> {t('playground.createPost')}
      </Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field>
            <TextArea
              value={content}
              onChange={(_, d) => setContent(d.value as string)}
              placeholder={t('playground.postPlaceholder')}
              rows={4}
              maxLength={512}
              style={{ resize: 'none' }}
            />
            <div style={{ textAlign: 'right', fontSize: '0.78em', color: content.length > 490 ? '#ef4444' : '#aaa', marginTop: 2 }}>
              {content.length}/512
            </div>
          </Form.Field>

          <Form.Field>
            <label>{t('playground.mediaLink')}</label>
            <input
              value={mediaUrl}
              onChange={e => setMediaUrl(e.target.value)}
              placeholder='https://...'
              type='url'
            />
            <div style={{ fontSize: '0.78em', color: '#888', marginTop: 2 }}>
              {t('playground.mediaLinkHint')}
            </div>
          </Form.Field>

          <Form.Field>
            <label>{t('playground.whoCanSee')}</label>
            <Dropdown
              selection
              options={visibilityOptions}
              value={visibility}
              onChange={(_, d) => setVisibility(d.value as PostVisibility)}
              fluid
            />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleClose}>{t('playground.cancel')}</Button>
        <Button
          primary
          disabled={!content.trim() || submitting}
          loading={submitting}
          onClick={handleSubmit}
        >
          {t('playground.post')}
        </Button>
      </Modal.Actions>
    </Modal>
  );
});